import React, { useContext, useEffect, useState } from "react";

import AccountBalanceIcon from "@material-ui/icons/AccountBalance";

import Title from "../../components/basics/Title";
import TabsErp from "../../components/tabs/TabsErp";
import CNDTabControle from "./CNDTabControle";
import CNDTabControleCliente from "./CNDTabControleCliente";
import CNDTabListagem from "./CNDTabListagem";
import CNDStepper from "./modal/CNDStepper";
import {
  findCNDConfig,
  updateCNDConfig,
} from "../../repository/ERP/pub/CNDConfigService";
import { QueryParamsContext } from "../../context/QueryParamsContext";
import "./CND.css";

const CNDPainel = () => {
  const [tabIndex, setTabIndex] = useState(
    sessionStorage.tabCNDPainel ? parseInt(sessionStorage.tabCNDPainel) : 0
  );
  const [openStepper, setOpenStepper] = useState(false);
  const [children, setChildren] = useState([<CNDTabControleCliente key="0" />]);
  const [headers, setHeaders] = useState([
    {
      label: "Controle",
    },
  ]);
  const { queryParams } = useContext(QueryParamsContext);

  useEffect(() => {
    if (queryParams.tipo_usuario === "contador") {
      setChildren([<CNDTabListagem key="0" />, <CNDTabControle key="1" />]);
      setHeaders([
        {
          label: "Cadastro",
        },
        {
          label: "Controle",
        },
      ]);

      if (!sessionStorage.tabCNDPainel) setTabIndex(1);
    }
  }, [queryParams.tipo_usuario]);

  useEffect(() => {
    if (queryParams.tipo_usuario !== "contador") return;

    (async () => {
      try {
        const { data } = await findCNDConfig(
          queryParams.empresa_cnpj,
          "tutorial_tela_inicial",
          queryParams.id_usuario
        );

        if (data && !data.value) {
          setOpenStepper(true);

          updateCNDConfig(
            queryParams.empresa_cnpj,
            "tutorial_tela_inicial",
            true,
            queryParams.id_usuario
          );
        }
      } catch (error) {
        console.error("error useEffect findCNDConfig CNDPainel", error);
      }
    })();
  }, [
    queryParams.empresa_cnpj,
    queryParams.id_usuario,
    queryParams.tipo_usuario,
  ]);

  return (
    <div className="fluid-container">
      <CNDStepper open={openStepper} setOpen={setOpenStepper} />
      <div className="container">
        <Title titulo="CND - Painel de Controle" icon={AccountBalanceIcon} />
        <TabsErp
          headers={headers}
          children={children}
          tabIndex={tabIndex}
          onChange={(event, value) => {
            if (Number.isInteger(value)) {
              setTabIndex(value);
              sessionStorage.setItem("tabCNDPainel", value);
            }
          }}
        />
      </div>
    </div>
  );
};

export default CNDPainel;
